import { t } from '@lingui/macro'
import { useNavigate } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { breakpoints } from '@/config/layout'
import { useHideNativeNavigation } from '@/layout/providers/LayoutProvider'
import { mixpanel } from '@/mixpanel'
import { CareQuestionDetailContentLayout } from '@/modules/care-question/components/care-question-detail-content-layout/CareQuestionDetailContentLayout'
import { SourceCard } from '@/modules/shared/components/source-card/SourceCard'
import { openUrl } from '@/utils/external-resources'

export const ContactPage = () => {
  // Hooks
  // ------------------------------------------------------------------------- /
  const navigate = useNavigate()
  const theme = useTheme()

  // Hide navigation on native devices
  useHideNativeNavigation()

  // Template variables
  // ------------------------------------------------------------------------- /
  const supportPhone = '+32 9 246 75 75'

  // Interactions handlers
  // ------------------------------------------------------------------------- /
  // Temporary disabled
  // const handleMessage = () => {
  //   mixpanel.track('app_question_message_to_support')
  //   navigate('message')
  // }

  const handleCall = () => {
    mixpanel.track('app_question_call_to_support', {
      phone: supportPhone,
    })
    openUrl(`tel:${supportPhone}`)
  }

  const handleGoBack = () => {
    mixpanel.track('app_question_go_back')
    navigate(-1)
  }

  const handleClose = () => {
    mixpanel.track('app_question_close_flow')
    navigate('/', { replace: true })
  }

  // Render
  // ------------------------------------------------------------------------- /
  return (
    <CareQuestionDetailContentLayout
      header={{
        primaryAction: {
          icon: ['far', 'chevron-left'],
          label: t({ id: 'globals.back', message: 'Terug' }),
          onClick: handleGoBack,
        },
        secondaryAction: {
          icon: ['far', 'close'],
          reverse: true,
          label: t({ id: 'globals.close', message: 'Sluiten' }),
          onClick: handleClose,
        },
      }}
      onClose={handleClose}
    >
      <StContainer gap={theme.UI.Spacing.Space4}>
        <H2 noMargin>
          {t({
            id: 'care-question.care-question.app-question.title',
            message: 'Contacteer ons via telefoon',
          })}
        </H2>
        <P type='BodyMediumRegular' style={{ fontWeight: 400 }}>
          {t({
            id: 'care-question.care-question.app-question.message',
            message: 'Problemen met inloggen of andere functionaliteiten in de app? Neem gerust contact op.',
          })}
        </P>

        {/*Temporary disabled*/}
        {/*<ExternalSourceCard*/}
        {/*  title={t({*/}
        {/*    id: 'care-question.care-question.app-question.message.title',*/}
        {/*    message: 'Stuur ons een bericht',*/}
        {/*  })}*/}
        {/*  onClick={handleMessage}*/}
        {/*/>*/}
        <SourceCard
          title={t({
            id: 'care-question.care-question.app-question.phone.title',
            message: 'Bel ons',
          })}
          description={t({
            id: 'care-question.care-question.app-question.phone.description',
            message: '+32 9 246 75 75 - enkel beschikbaar tijdens de werkuren',
          })}
          onClick={handleCall}
        />
      </StContainer>
    </CareQuestionDetailContentLayout>
  )
}

const StContainer = styled(FlexColumn)`
  display: flex;
  flex-direction: column;
  justify-content: end;
  height: 100%;
  @media ${breakpoints.fromS} {
    justify-content: start;
    min-width: 600px;
  }
`
